import React, { useEffect, useState } from 'react';
import { FaQuoteLeft, FaStar, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import testimonialImage from '../../assets/testimonial-image.jpg';
import './Testimonials.css';

const Testimonials = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    const element = document.querySelector('.testimonials-container');
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, []);

  const testimonials = [
    {
      name: 'Rajesh Kumar',
      position: 'CEO, TechStart Solutions',
      image: testimonialImage,
      rating: 5,
      text: 'Redfox Digital truly understood our industry and audience. Their tailored strategy—combining content marketing, email automation, and paid ads—has delivered great results. Highly recommended for any business aiming to grow digitally.'
    },
    {
      name: 'Priya Sharma',
      position: 'Founder, EcoGreen Products',
      image: testimonialImage,
      rating: 5,
      text: 'Redfox Digital transformed our online presence completely. Their team created a beautiful, functional e-commerce website that not only looks professional but also drives real sales. The attention to detail and ongoing support has been exceptional. Our online sales have increased by 300% since launching the new site.'
    },
    {
      name: 'Amit Patel',
      position: 'Director, Modern Retail Group',
      image: testimonialImage,
      rating: 5,
      text: 'Working with Redfox Digital has been a game-changer for our business. They delivered a custom web application that streamlined our entire inventory management system. The project was completed on time, within budget, and exceeded our expectations. Their post-launch support has been outstanding.'
    },
    {
      name: 'Sneha Reddy',
      position: 'Marketing Head, Digital Innovations',
      image: testimonialImage,
      rating: 5,
      text: 'The SEO and digital marketing services provided by Redfox Digital have significantly improved our online visibility. We have seen a 250% increase in organic traffic and our lead generation has doubled. Their strategic approach and transparent reporting make them a trusted partner for our business growth.'
    }
  ];

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="testimonials-section section">
      <div className="container">
        <div className="section-title">
          <span className="section-subtitle">Testimonials</span>
          <h2>What Our Clients Say About Us</h2>
          <p>
            Don't just take our word for it - hear from the businesses we've helped 
            transform their digital presence and achieve remarkable growth.
          </p>
        </div>

        <div className={`testimonials-container ${isVisible ? 'visible' : ''}`}>
          <div className="testimonials-slider">
            {testimonials.map((testimonial, index) => (
              <div 
                key={index}
                className={`testimonial-card ${index === currentTestimonial ? 'active' : ''}`}
              >
                <div className="testimonial-content">
                  <div className="quote-icon">
                    <FaQuoteLeft />
                  </div>
                  
                  <div className="rating">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <FaStar key={i} className="star" />
                    ))}
                  </div>
                  
                  <p className="testimonial-text">"{testimonial.text}"</p>
                  
                  <div className="testimonial-author">
                    <div className="author-image">
                      <img src={testimonial.image} alt={testimonial.name} />
                    </div>
                    <div className="author-info">
                      <h4 className="author-name">{testimonial.name}</h4>
                      <p className="author-position">{testimonial.position}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="testimonials-navigation">
            <button className="nav-btn prev-btn" onClick={prevTestimonial}>
              <FaArrowLeft />
            </button>
            
            <div className="testimonials-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => setCurrentTestimonial(index)}
                />
              ))}
            </div>
            
            <button className="nav-btn next-btn" onClick={nextTestimonial}>
              <FaArrowRight />
            </button>
          </div>
        </div>

        <div className="testimonials-stats">
          <div className="stat-item">
            <span className="stat-number">98%</span>
            <span className="stat-label">Client Satisfaction</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">200+</span>
            <span className="stat-label">Happy Clients</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">5.0</span>
            <span className="stat-label">Average Rating</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
